import {
  APPROVE_OR_REJECT_EGEN_CONTROL_ACTION_URL,
  CREATE_EGEN_CONTROL_QUALITY_CHECK,
  DELETE_ALL_EGEN_CONTROL_QUALITY_CHECKS,
  DELETE_EGEN_CONTROL_QUALITY_CHECK,
  RETRIEVE_EGEN_CONTROL_QUALITY_CHECK,
  RETRIEVE_EGEN_CONTROL_QUALITY_CHECK_REPORT,
  UPDATE_EGEN_CONTROL_QUALITY_CHECK,
  VALIDATE_EGEN_CONTROL_ACTION_URL,
} from "../constants";

const initialState = {
  data: [],
  detail: [],
  page: 0,
  sizePerPage: 0,
  totalSize: 0,
  isLoading: true,
  isLoadingReport: false,
  isValid: false,
  isApprove: false,
};

export default function reducer(state = initialState, actions) {
  const { type, payload } = actions;
  switch (type) {
    case RETRIEVE_EGEN_CONTROL_QUALITY_CHECK_REPORT:
      return {
        ...state,
        isLoadingReport: payload,
      };
    case CREATE_EGEN_CONTROL_QUALITY_CHECK:
      return {
        ...state,
        data: [...state.data, { ...payload }],
        isLoading: false,
      };
    case RETRIEVE_EGEN_CONTROL_QUALITY_CHECK:
      return {
        ...state,
        detail: [payload],
        isLoading: false,
      };
    case UPDATE_EGEN_CONTROL_QUALITY_CHECK:
      return {
        ...state,
        data: state.data.map((qualityCheck) => {
          if (qualityCheck.publicId === payload.publicId) {
            return {
              ...qualityCheck,
              ...payload,
            };
          } else {
            return qualityCheck;
          }
        }),
        isLoading: false,
      };

    case DELETE_EGEN_CONTROL_QUALITY_CHECK:
      return {
        ...state,
        data: state.data.filter(
          ({ publicId }) => publicId !== payload.publicId
        ),
        isLoading: false,
      };

    case DELETE_ALL_EGEN_CONTROL_QUALITY_CHECKS:
      return [];

    case VALIDATE_EGEN_CONTROL_ACTION_URL:
      return {
        ...state,
        isValid: payload,
        isLoading: false,
      };

    case APPROVE_OR_REJECT_EGEN_CONTROL_ACTION_URL:
      return {
        ...state,
        isApprove: payload,
        isLoading: false,
      };

    default:
      return state;
  }
}
